export enum PageDetailModeEnum {
    NEW = 'NEW',
    NEW_PRICE_CARD = 'NEW_PRICE_CARD',
    EDIT = 'EDIT'
}
